module.exports = __webpack_public_path__ + "img/georg3.84ce38a4.jpg";